import React, { useState } from "react";
import { Col, Container, Form, Input, Label, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { Btn, H2, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { EmailAddress, ForgotPasswordText,SendEmail } from "../../utils/Constant";
import { useForgot } from "./useAuth";
import { FaArrowLeft } from "react-icons/fa";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const forgotPassApi=useForgot();

  const SimpleLoginHandle = (event: React.FormEvent<HTMLFormElement>) => {


    event.preventDefault();

    forgotPassApi.mutate(
        {username:email}, // Pass credentials as an object 
      {
        onError: (error) => {
          console.error("forgot failed:", error);
        },
      }
    );
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        
        <Col xs="12" className="p-0">
      
          <div className="login-card login-dark">
            
            <div>
              <div>
                <Link className="logo text-center" to="#">
                  <Image
                    style={{ width: "25%" }}
                    src={dynamicImage("logo/Truesales.png")}
                    alt="logo"
                  />
                </Link>
              </div>
              <div className="login-main">
                  <div
                        style={{
                          backgroundColor: "#E6F3F3",
                          padding: "6px",
                          borderRadius: "10%",
                          display: "flex",
                          alignItems: "center",
                          // justifyContent: "center",
                          cursor: "pointer",
                          width:25
                        }}
                        onClick={() => navigate(-1)}
                      >
                        <FaArrowLeft size={15} color="#4BBCB5" />
                      </div>
                <Form className="theme-form" onSubmit={SimpleLoginHandle}>
                  <H2 className="text-center">{ForgotPasswordText}</H2>
                  <P className="text-center">
                    {"Enter your email ID to request a password reset"}
                  </P>
                  <div className="form-group">
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input
                      type="email"
                      required
                      placeholder="Enter Email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </div>
                  <div className="text-end mt-3">
                    <Btn color="primary" block className="w-100">
                      {SendEmail}
                    </Btn>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
